import { MonsterInterface as IMonster } from "../../models/interfaces/projectFormMonsters/Monster.interface";
import { ProjectInterface as IProject } from "../../models/interfaces/project.interface";
import { type } from '../utils/util';

export class ActiveFormActions {
    static SET_FORM = type('SET_FORM');
    static SET_FORM_STEP = type('SET_FORM_STEP');
    static SET_FORM_STATE = type('SET_FORM_STATE');
    static ADD_OR_UPDATE_MONSTER = type('ADD_OR_UPDATE_MONSTER');
    static SYNC_ACTIVE_PROJECT = type('SYNC_ACTIVE_PROJECT');
    static SYNC_ACTIVE_PROJECT_ID = type('SYNC_ACTIVE_PROJECT_ID');
    static SYNC_ACTIVE_PROJECT_MONSTER_ID = type('SYNC_ACTIVE_PROJECT_MONSTER_ID');
    static SET_DIRTY = type('SET_DIRTY');
    static DELETE_MONSTER = type('DELETE_MONSTER');

    setForm(payload: { project: IProject }) {
        return {
            type: ActiveFormActions.SET_FORM,
            payload: payload
        };
    }

    setFormStep(payload: { step: string }) {
        return {
            type: ActiveFormActions.SET_FORM_STEP,
            payload: payload
        };
    }

    setFormState(payload: { step: string, fields: {}, valid: boolean }) {
        return {
            type: ActiveFormActions.SET_FORM_STATE,
            payload: payload
        };
    }

    addOrUpdateMonster(payload: { monster: IMonster }) {
        return {
            type: ActiveFormActions.ADD_OR_UPDATE_MONSTER,
            payload: payload
        }
    }

    syncActiveProjectId(payload: { id: number }) {
      return {
        type: ActiveFormActions.SYNC_ACTIVE_PROJECT_ID,
        payload: payload
      }
    }

    syncActiveProjectMonsterId(payload: { id: number, monsterCode: any }) {
      return {
        type: ActiveFormActions.SYNC_ACTIVE_PROJECT_MONSTER_ID,
        payload: payload
      }
    }

    setDirty(payload: { dirty: boolean }) {
        return {
            type: ActiveFormActions.SET_DIRTY,
            payload: payload
        }
    }

    deleteMonster(payload: { projectId: number; monsterId: number}) {
      return {
        type: ActiveFormActions.DELETE_MONSTER,
        payload: payload
      }
    }
}



// WEBPACK FOOTER //
// ./src/states/activeForm/active-form.actions.ts